import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  Snackbar,
  Alert,
} from "@mui/material";
import { motion } from "framer-motion";
import emailjs from "emailjs-com"; // <-- Import EmailJS
import backgroundImage from "../images/container.jpg";
import RightImg from "../images/Gemini_Generated_Image_8v3p8o8v3p8o8v3p.png";

const Contact = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // EmailJS send
    emailjs
      .send(
        "YOUR_SERVICE_ID", // <-- replace with your EmailJS service ID
        "YOUR_TEMPLATE_ID", // <-- replace with your EmailJS template ID
        formData,
        "YOUR_PUBLIC_KEY" // <-- replace with your EmailJS public key
      )
      .then(
        (result) => {
          console.log("Email sent successfully:", result.text);
          setSnackbar({
            open: true,
            message: "Message sent successfully!",
            severity: "success",
          });
          setFormData({
            fullName: "",
            email: "",
            phone: "",
            subject: "",
            message: "",
          });
        },
        (error) => {
          console.error("Error sending email:", error.text);
          setSnackbar({
            open: true,
            message: "Failed to send message. Please try again.",
            severity: "error",
          });
        }
      );
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        py: { xs: 4, md: 6 },
        px: 2,
      }}
    >
      <Paper
        component={motion.div}
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        elevation={8}
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          width: "100%",
          maxWidth: 1100,
          borderRadius: 3,
          overflow: "hidden",
          backdropFilter: "blur(8px)",
          backgroundColor: "rgba(255,255,255,0.92)",
          boxShadow: "0 10px 40px rgba(0,0,0,0.25)",
        }}
      >
        {/* Left Side - Form */}
        <Box
          sx={{
            flex: { xs: "1 1 auto", md: "0 0 45%" },
            p: { xs: 3, sm: 4, md: 5 },
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="h4"
            gutterBottom
            sx={{
              textAlign: "center",
              color: "#e64a14",
              fontWeight: "bold",
              mb: 3,
            }}
          >
            Get in Touch
          </Typography>

          <form onSubmit={handleSubmit}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
              {[
                { label: "Full Name", name: "fullName", type: "text" },
                { label: "Email", name: "email", type: "email" },
                { label: "Phone", name: "phone", type: "text" },
                { label: "Subject", name: "subject", type: "text" },
              ].map((field) => (
                <TextField
                  key={field.name}
                  label={field.label}
                  name={field.name}
                  value={formData[field.name]}
                  onChange={handleChange}
                  type={field.type}
                  fullWidth
                  required={field.name !== "phone"}
                  variant="standard"
                  InputProps={{
                    disableUnderline: true,
                    sx: { fontSize: "0.95rem" },
                  }}
                  InputLabelProps={{
                    sx: {
                      fontSize: "0.9rem",
                      "&.Mui-focused": { color: "#ff5b1f", fontWeight: "500" },
                    },
                  }}
                  sx={{
                    borderBottom: "1px solid #bbb",
                    pb: 0.5,
                  }}
                />
              ))}

              <TextField
                label="Message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                multiline
                rows={4}
                fullWidth
                required
                variant="standard"
                InputProps={{
                  disableUnderline: true,
                  sx: { fontSize: "0.9rem" },
                }}
                InputLabelProps={{
                  sx: {
                    fontSize: "0.9rem",
                    "&.Mui-focused": {
                      color: "#ff5b1f",
                      fontWeight: "500",
                    },
                  },
                }}
                sx={{
                  borderBottom: "1px solid #bbb",
                  pb: 0.5,
                }}
              />

              <Button
                type="submit"
                variant="contained"
                fullWidth
                sx={{
                  background: "linear-gradient(90deg, #ff5b1f, #ff8146)",
                  py: 1.2,
                  fontWeight: "bold",
                  fontSize: "1rem",
                  borderRadius: 2,
                  mt: 1,
                  textTransform: "none",
                  "&:hover": {
                    background: "linear-gradient(90deg, #e64a14, #ff6530)",
                  },
                }}
              >
                Submit Message
              </Button>
            </Box>
          </form>
        </Box>

        {/* Right Side - Image */}
        <Box
          sx={{
            flex: { xs: "1 1 auto", md: "0 0 55%" },
            minHeight: { xs: 500, md: 500 },
            position: "relative",
          }}
        >
          <Box
            component="img"
            src={RightImg}
            alt="Contact Illustration"
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "contain",
              objectPosition: "center",
              backgroundColor: "#fff",
            }}
          />
        </Box>
      </Paper>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Contact;
